import React, { useState, useEffect } from 'react'
import { M0041Props, Alignment } from './types'
import { ComponentHelper, getWrapperProps } from '../../../../helpers/ComponentHelper'
import {
  StyledWrapper,
  StyledHeroImageWrapper,
  StyledHeroImage,
  StyledHeroBlurryImage,
  StyledHeroCopyWrapper,
  StyledHeroHeading,
  StyledHeroVoucherCode,
  StyledLegalCopy
} from './M0041.styles'
/**
 * - M004.1 is a banner with Promo Vouchers.
 * - It can be authored with a heading and with or without a subheading, legal copy, voucher code and link.
 * - The text can be left or center aligned.
 * */

const M0041 = ({
  colorOverlay,
  heading,
  subheading,
  voucherCode,
  linkUrl,
  linkTitle,
  linkTarget,
  alignment = Alignment.CENTER,
  onLinkClick,
  backgroundImageUrl,
  legalCopy,
  type
}: M0041Props): React.ReactElement => {
  const [backgroundStyle, setBackgroundStyle] = useState('')
  useEffect(() => {
    setBackgroundStyle(
      backgroundImageUrl
        ? `url('${ComponentHelper.dynamicImageParams(backgroundImageUrl, ComponentHelper.windowWidth(), type)}')`
        : null
    )
  }, [backgroundImageUrl, ComponentHelper.windowWidth(), type])

  const backgroundStyleStart = `url('${ComponentHelper.dynamicImageParams(backgroundImageUrl)}')`

  const baseWrapperProps = {
    stack: 'xs',
    gutterValue: 0
  }
  return (
    <StyledWrapper
      data-test='m0041-container'
      target={linkTarget}
      {...getWrapperProps(linkTitle, linkUrl, onLinkClick, baseWrapperProps)}
    >
      <StyledHeroImageWrapper data-test='m0041-image-container' colorOverlay={colorOverlay} />
      {backgroundImageUrl && (
        <>
          <StyledHeroImage data-test='m0041-image' backgroundImage={backgroundStyle} />
          <StyledHeroBlurryImage data-test='m0041-blurry-image' backgroundImage={backgroundStyleStart} />
        </>
      )}
      <StyledHeroCopyWrapper
        data-test='m0041-text-container'
        stack='xs'
        gutterValue={0}
        hasLegalCopy={!!legalCopy}
        textAlignment={alignment}
      >
        <StyledHeroHeading data-test='m0041-heading'>{heading}</StyledHeroHeading>
        {subheading && <p data-test='m0041-subheading'>{subheading}</p>}
        {voucherCode && (
          <StyledHeroVoucherCode data-test='m0041-voucher' alignment={alignment} colorOverlay={colorOverlay}>
            {voucherCode}
          </StyledHeroVoucherCode>
        )}
        {legalCopy && <StyledLegalCopy data-test='m0041-legalCopy'>{legalCopy}</StyledLegalCopy>}
      </StyledHeroCopyWrapper>
    </StyledWrapper>
  )
}
export default M0041
